/* chat-entry.js - opens the Shopify Inbox chat from any [data-chat-open] link.

   Emitted by snippets/chat-entry.liquid, which can be rendered more than once
   on a page (a product page and a section on the same route), so the module
   guards itself: a second copy of the script returns before it binds a second
   listener.

   ONE DELEGATED LISTENER ON THE DOCUMENT, not one per link. The links arrive in
   server markup and also in markup swapped in later (the Section Rendering API
   re-renders the product section on a variant change), and a listener on the
   document needs no rebinding for either.

   THE LINK IS THE FALLBACK AND THIS IS ONLY THE ENHANCEMENT. The default action
   is cancelled ONLY when there is an upgraded <shopify-chat> to hand the click
   to: the element must exist (the app embed is enabled) and `show` must be a
   function (its custom element definition has run; before that the tag is an
   inert HTMLElement). Anything else, and the click stays an ordinary navigation
   to the href, /pages/contact. A modified click (new tab, new window) is always
   left to the browser: the shopper asked for the page, not the chat. */
(function () {
  'use strict';

  if (window.ppChatEntryLoaded) return;
  window.ppChatEntryLoaded = true;

  function modified(event) {
    return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || modified(event)) return;
    var target = event.target;
    var link = target && target.closest ? target.closest('[data-chat-open]') : null;
    if (!link) return;
    var chat = document.querySelector('shopify-chat');
    if (!chat || typeof chat.show !== 'function') return;
    event.preventDefault();
    chat.show();
  });
})();
